<template>
  <v-container class="py-12 mt-12 chapter-next" fluid v-if="nextChapter">
    <ArrowIcon @click.stop="onPrevClick" class="arrow-icon ml-1 ml-md-12 arrow-icon--reverted prev" />
    <ArrowIcon @click.stop="onNextClick" class="arrow-icon mr-1 mr-md-12 next" />

    <v-row justify="center" class="py-12 my-12">
      <transition name='fade' mode="out-in">
        <v-col cols="10" md="6" offset-md="1" class="py-12 my-12" :key="currentChapter.toString()">
          <ChapterIndex :value="currentChapter.toString()" />
          <h3 class="font-weight-bold" :class="{'coming-soon': comingSoon}">{{nextChapter.title}}</h3>
          <p v-if="comingSoon" class="mt-1" v-translate>Register to our newsletter to know when this chapter will be available.</p>
          <a v-if="comingSoon" target="_blank" :href="$language.current === 'it' ? 'https://landing.mailerlite.com/webforms/landing/z3c3t0' : 'https://landing.mailerlite.com/webforms/landing/j1p4d8'" >
            <TextCta :copy="copyRemindMe" />
          </a>

          <p v-if="!comingSoon" class="mt-1"><span v-translate>Would you like to read the rest of this story?</span><br>
            <a class="coming-soon" v-translate v-if="!comingSoon" target="_blank" :href="$language.current === 'it' ? 'https://landing.mailerlite.com/webforms/landing/z3c3t0' : 'https://landing.mailerlite.com/webforms/landing/j1p4d8'" >
              Register to our newsletter
            </a> <span v-translate>to know when this chapter will be updated. </span>
          </p>
          <router-link  v-if="!comingSoon" :to="{ name: 'Chapter', params: { chapterSlug: nextChapter._slug, chapterId: currentChapter }}">
            <TextCta :copy="$root.siteSettings.genericExploreText" />
          </router-link>
        </v-col>
      </transition>
    </v-row>
  </v-container>

</template>

<script>
import ChapterIndex from '@/atoms/ChapterIndex'
import TextCta from '@/atoms/TextCta'
import ArrowIcon from '@/assets/svg/arrow.svg'

export default {
  name: 'ChapterNext',

  components: {
    ChapterIndex,
    TextCta,
    ArrowIcon
  },
  // this.$root.chapters[this.chapterId + 1][this.$route.params.language]
  data () {
    return {
      nextChapter: null,
      comingSoon: false,
      currentChapter: 0,
      copyRemindMe: this.$gettext('Remind Me'),
      copyExplore: this.$gettext('Explore')
    }
  },

  mounted () {
    this.currentChapter = this.nextChapterId
    this.updateChapter()
  },

  methods: {
    updateChapter () {
      this.nextChapter = this.$root.chapters[this.currentChapter][this.$route.params.language]
      this.comingSoon = this.$root.chapters[this.currentChapter].comingSoon
    },

    onNextClick () {
      this.currentChapter = (this.currentChapter + 1 >= this.$root.chapters.length) ? 0 : this.currentChapter + 1
      this.updateChapter()
    },

    onPrevClick () {
      this.currentChapter = (this.currentChapter - 1 < 0) ? this.$root.chapters.length - 1 : this.currentChapter - 1
      this.updateChapter()
    }
  },

  props: {
    nextChapterId: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">

.chapter-next {
  box-shadow: 3px -3px 10px rgba(0, 0, 0, 0.85);
  background-color: #0e0e0e;
  pointer-events: all;
  position: relative;
  min-height: 90vh;

  h4 {
    color: $c-text-grey;
  }

  h3 {
    color: $c-white;

    &.coming-soon {
      color: $c-text-grey;
    }
  }

  a {
    color: $c-red;

    &.coming-soon {
      color: $c-white;
      text-decoration: underline;
    }
  }

  p {
    color: $c-white;
  }
}

.arrow-icon {
  height: 15px;
  width: 15px;
  margin-top: 15px;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.4s;
  transform: translateY(-50%);
  position: absolute;
  top: 45%;
  left: 0;

  @include breakpoint('md-and-up') {
    margin-top: 20px;
    height: 25px;
    width: 25px;
  }

  &.next {
    left: auto;
    right: 0;
  }

  &:hover {
    opacity: 1;
  }

  &--reverted {
    transform: translateY(-50%) rotate(-180deg);
  }
}

::v-deep .v-btn {
  text-transform: none;
}

</style>
